const $ = jQuery.noConflict();

'use strict';
const SetPassword = {

	// properties
	$domForm: null,
	$domSubmit: null,
	$domResponse: null,

	// initialize
	init: function() {
		if ($('.js-set-password').length === 0) {
			return;
		}
		this.initDom();
		this.bindEvents();
		this.updateSubmitButton();
	},


	// set $dom variables
	initDom: function() {
		SetPassword.$domForm = $('.js-set-password__form');
		SetPassword.$domSubmit = SetPassword.$domForm.find('.js-set-password--btn');
		SetPassword.$domResponse = SetPassword.$domForm.find('.js-response');
	},

	// attach events
	bindEvents: function() {
		// intercept submission
		SetPassword.$domForm.on('submit', function() {
			const destiny = SetPassword.validateForm();
			if (destiny === true) {
				SetPassword.sendRequest();
			} else {
				SetPassword.responseMessage(destiny, true);
			}
			return false; // always reject
		});
		// inputs
		SetPassword.$domForm.find('input').on('input change', function(){
			SetPassword.updateSubmitButton();
		});
		// btn
		SetPassword.$domSubmit.on('click', function(e) {
			e.preventDefault();
			SetPassword.$domForm.trigger('submit');
		});
	},

	// check form content
	validateForm: function() {
		const form = SetPassword.$domForm.serializeArray();
		const regExp = /^[a-zA-Z]*$/;
		// first field is required
		if (form[0].value === '') {
			return 'Password field is required';
		}
		// second field is required
		if (form[1].value === '') {
			return 'Confirm password is required';
		}
		// value length
		if (form[0].value.length < 8) {
			return 'The password requires at least 8 characters';
		}
		// the first field must to have a special characters
		if (regExp.test(form[0].value)) {
			return 'The password requires at least 1 special character';
		}
		// passwords must match
		if (form[0].value !== form[1].value) {
			return 'Passwords have to match';
		}
		return true;
	},

	// update state of "submit" button
	updateSubmitButton: function() {
		SetPassword.$domSubmit.toggleClass('btn-disabled', SetPassword.validateForm() !== true);
	},

	// send form submission
	sendRequest: function() {
		SetPassword.$domSubmit.addClass('btn-disabled');
		SetPassword.responseMessage('');
		const formValues = SetPassword.$domForm.serializeArray();
		formValues.push({name: 'action', value: 'set-password'});
		// dispatch request
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: formValues,
			success: function(response) {
				if (response.success === false) {
					SetPassword.responseMessage(response.data.html, true);
				}
				if (response.success === true) {
					SetPassword.clearForm();
					SetPassword.responseMessage('You have successfully set a new password.', false);
					window.location.href = window.location.origin;
				}
			},
			complete: function() {
				SetPassword.$domSubmit.removeClass('btn-disabled');
			}
		});
	},

	// display message
	responseMessage: (msg, asError) => {
		SetPassword.$domResponse
			.html(msg)
			.toggleClass('error-wrap', msg !== '' && asError);
	},

	// empty inputs
	clearForm: function() {
		SetPassword.$domForm.find('input').val('');
		SetPassword.updateSubmitButton();
	},
};

export default SetPassword;
